import Button from '@/components/atoms/button';
import Input from '@/components/atoms/input';
import { InputValidatorType } from '@/core/presenter/viewModel';
import clsx from 'clsx';

interface IProps {
  prePassword: string;
  isPrePasswordCheckedBtn: boolean;
  onChangePassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onClickPwdNextBtn: () => void;
}

const PwdSettingView = ({ isPrePasswordCheckedBtn, prePassword, onChangePassword, onClickPwdNextBtn }: IProps) => {
  return (
    <div className="container-style2">
      <div className="inner-set-pnum">
        <h3 className="form-title body-l-n fw-b">비밀번호 재설정</h3>
        <div className="form-group-info">
          <div className="pwd_setting_div">
            <label className="pwd_setting_label">기존 비밀번호를 입력해주세요</label>
          </div>
          <div className="input-group">
            <Input
              type="password"
              className="body-n-n"
              id="auth-code"
              placeholder="기존 비밀번호 입력"
              validatorType={InputValidatorType.PASSWORD}
              value={prePassword}
              onChange={onChangePassword}
            />
          </div>
        </div>
        <div className="button-area magin-top-10">
          <Button
            caption="완료"
            className={clsx('body-n-n fw-b', {
              show_important: !isPrePasswordCheckedBtn,
              solid: !isPrePasswordCheckedBtn,
              disabled: isPrePasswordCheckedBtn,
            })}
            disabled={isPrePasswordCheckedBtn}
            onClick={onClickPwdNextBtn}
          />
        </div>
      </div>
    </div>
  );
};

export default PwdSettingView;
